'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('application', {
      url: '/application',
      redirectTo: 'application.contact',
      template: '<application settings="$resolve.settings"></application>',
      params: { homeownerApp: null },
      resolve: {
        settings(Settings) {
          return Settings.lookup();
        }
      }
    })
    .state('application.contact', {
      url: '/contact',
      template: require('./contact.html')
    })
    .state('application.mailing', {
      url: '/mailing',
      template: require('./mailing.html')
    })
    .state('application.beach', {
      url: '/beach',
      template: require('./beach.html')
    })
    .state('application.vehicle', {
      url: '/vehicle',
      template: require('./vehicle.html')
    })
    .state('application.agreement', {
      url: '/agreement',
      template: require('./agreement.html')
    })
    .state('application.payment', {
      url: '/payment',
      template: require('./payment.html')
    })
    .state('application.review', {
      url: '/review',
      template: require('./review.html')
    })
    .state('application.complete', {
      url: '/complete',
      template: require('./complete.html')
    });
}



// WEBPACK FOOTER //
// ./client/app/application/application.routes.js